import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { to: "/dashboard", label: "Home" },
  { to: "/books", label: "Books" },
  { to: "/recipes", label: "Recipes" },
  { to: "/tvshows", label: "TV" },
  { to: "/restaurants", label: "Restaurants" },
];

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isLoggedIn = localStorage.getItem("token") != null;

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const linkClasses =
    "block px-3 py-2 rounded-md text-stone-700 hover:bg-stone-100 hover:text-teal-700";

  return (
    <div className="min-h-screen flex flex-col">
      {isLoggedIn && (
        <header className="fixed top-0 inset-x-0 z-50 bg-white border-b border-stone-200">
          <nav className="flex items-center justify-between px-4 py-3">
            <span className="font-semibold text-teal-700">Listography</span>

            <ul className="hidden md:flex items-center gap-1">
              {navLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className={linkClasses}>
                    {label}
                  </Link>
                </li>
              ))}
              <li>
                <button onClick={handleLogout} className="btn-secondary">
                  Logout
                </button>
              </li>
            </ul>

            <button
              type="button"
              className="md:hidden p-2 rounded-md text-stone-700 hover:bg-stone-100"
              aria-label="Toggle menu"
              aria-expanded={isMenuOpen}
              onClick={() => setIsMenuOpen((open) => !open)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </nav>

          {isMenuOpen && (
            <ul className="md:hidden flex flex-col gap-1 border-t border-stone-200 px-4 py-3">
              {navLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className={linkClasses}>
                    {label}
                  </Link>
                </li>
              ))}
              <li>
                <button
                  onClick={handleLogout}
                  className="btn-secondary w-full text-left"
                >
                  Logout
                </button>
              </li>
            </ul>
          )}
        </header>
      )}
      <main className={`flex-1 ${isLoggedIn ? "pt-20" : ""}`}>{children}</main>
    </div>
  );
};

export default Layout;
